<template>
  <div>
    <h1>Equipes</h1>

    <SGPBotaoAdicionarNovoComponent @sgpAdiconarNovoEmit="adicionarNovaEquipe" style="z-index: 1000;" />
    <SGPFormSelectComponent :name="'exibirItensDeletados'" :listaDeOptions="opcoesSelect" v-model="exibirItensDeletados"
      :optionLabel="'nome'" :placeholder="'Visualizar Itens Deletados'"
      :error="validationErrors.first('exibirItensDeletados')" data-vv-as="Visualizar Itens Deletados"
      :optionSelecione="'Não'" @change="filtrarEquipesDeletados($event)" />

    <template v-if="listaDeEquipes.length">
      <SGPPaginacaoComponent :paginacao="paginacao" @sgpAtualizarPaginacao="realizarPaginacao"
        :key="paginacao?.current_page">
        <SGPTabelaComponent v-if="listaDeEquipes.length" :colunas="colunas" :dados="listagemEquipes"
          @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
          @sgpTabelaEditarSelecionadoEmit="editarSelecionado" @sgpTabelaDeletarSelecionadoEmit="deletarSelecionados"
          @sgpTabelaRestaurarSelecionadoEmit="restaurarEquipeSelecionada">
          <template v-slot:item.selecionar="{ item }">
            <div class="container-botao-tabela">
              <SGPFormBotaoComponent
                fab
                rounded
                color="warning"
                @click="editarItem(item)"
                v-if="podeEditarOuDeletarEquipe(item)"
                x-small
                :disabled="item.deleted_at"
              >
                <v-icon color="white" small>mdi-pencil</v-icon>
              </SGPFormBotaoComponent>
              
              <SGPFormBotaoComponent
                class="ml-2"
                fab
                rounded
                color="primary"
                @click="excluirItem(item)"
                v-if="podeEditarOuDeletarEquipe(item)"
                x-small
                :disabled="item.deleted_at"
              >
                <v-icon color="white" small>mdi-delete</v-icon>
              </SGPFormBotaoComponent>
            </div>
          </template>
          <template v-slot:item.redirecionarUsuarios="{ item }">
            <SGPFormBotaoComponent
              fab
              rounded
              color="warning"
              :to="item.redirecionarUsuarios"
              x-small
              :disabled="item.deleted_at"
            >
              <v-icon color="white" small>mdi-link</v-icon>
            </SGPFormBotaoComponent>
          </template>
          <template v-slot:item.redirecionarTarefas="{ item }">
            <SGPFormBotaoComponent
              fab
              rounded
              color="warning"
              :to="item.redirecionarTarefas"
              x-small
              :disabled="item.deleted_at"
            >
              <v-icon color="white" small>mdi-link</v-icon>
            </SGPFormBotaoComponent>
          </template>
        </SGPTabelaComponent>
      </SGPPaginacaoComponent>
    </template>

    <SGPAlertaComponent v-else />

    <SGPModalComponent v-if="abrirModal" tamanho="sm" titulo="Equipe" @sgpModalFechar="fecharModal"
      :mostrarFooter="false">
      <FormularioEquipeComponent :tipoFormulario="tipoFormulario" :equipe="equipe" />
    </SGPModalComponent>

    <SGPConfirmacaoDelecaoComponent v-if="abrirModalDeletarDados" @sgpCancelarDelecaoEmit="cancelarDelecao()"
      @sgpConfirmarDelecaoEmit="confirmarDelecao()" />

    <SGPLoadingComponent v-if="loadingEquipe" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormularioEquipeComponent from '../components/FormularioEquipeComponent.vue'
import deletar from "@/././common/mixins/deletar.js";
import moduleReload from "@/common/mixins/module-reload.js";

export default {
  components: { FormularioEquipeComponent },
  name: 'CtrlEquipesPage',
  mixins: [deletar, moduleReload],
  data() {
    return {
      mostrarSelecionar: true,
      mostrarEditar: true,
      mostrarDeletar: true,
      equipesSelecionadas: [],
      abrirModal: false,
      abrirModalDeletarDados: false,
      tipoFormulario: 'salvar',
      equipe: {},
      exibirItensDeletados: false,
      usuarioPodeExcluir: true,
      opcoesSelect: [
        {
          'id': true,
          'nome': 'Sim'
        },
        {
          'id': false,
          'nome': 'Não'
        },
      ],
    }
  },

  created() {
    this.listarEquipes({
      exibirItensDeletados: this.exibirItensDeletados
    });
  },

  computed: {
    ...mapGetters('appCtrlEquipes', ['listaDeEquipes', 'loadingEquipe', 'paginacao']),

    listagemEquipes() {
      if (this.listaDeEquipes) {
        return this.listaDeEquipes.map(equipe => {
          equipe.redirecionarUsuarios = `/app/ctrl-equipes/${equipe.id}/usuarios`
          equipe.redirecionarTarefas = `/app/ctrl-equipes/${equipe.id}/tarefas`
          return equipe
        })
      }

      return []
    },

    colunas() {
      return [
        {
          key: 'selecionar',
          label: 'Ações',
          sortable: false
        },
        {
          key: 'restaurar',
          label: 'Restaurar'
        },
        {
          key: 'nome',
          label: 'Equipe',
          sortable: false,
          width: 200,
        },
        {
          key: 'descricao',
          label: 'Descrição',
          width: 500,
          sortable: false
        },
        {
          key: 'redirecionarUsuarios',
          label: 'Associar Usuários',
          sortable: false
        },
        {
          key: 'redirecionarTarefas',
          label: 'Associar Tarefas',
          sortable: false
        }
      ]
    }
  },

  methods: {
    ...mapActions('appCtrlEquipes', [
      'listarEquipes',
      'excluirEquipes',
      'restaurarEquipe'
    ]),

    montarParametros(extra = {}) {
      return {
        per_page: this.paginacao?.per_page || 20,
        page: this.paginacao?.current_page || 1,
        current_page: this.paginacao?.current_page || 1,
        ...extra,
      }
    },

    gerenciadorDeSelecionados(selecionados) {
      this.equipesSelecionadas = selecionados
    },

    restaurarEquipeSelecionada(equipe) {
      this.restaurarEquipe(equipe.id)
      this.exibirItensDeletados = false
      this.listarEquipes(this.montarParametros({
        exibirItensDeletados: this.exibirItensDeletados
      }))
    },

    adicionarNovaEquipe() {
      this.abrirModal = true
      this.tipoFormulario = 'salvar'
      this.equipe = {}
    },

    editarSelecionado() {
      this.tipoFormulario = 'editar'
      this.equipe = this.equipesSelecionadas[0]
      this.abrirModal = true
    },

    confirmarDelecao() {
      this.excluirEquipes(this.equipesSelecionadas);
      this.deletarDados = false;
    },

    fecharModal() {
      this.abrirModal = false
    },

    async realizarPaginacao(pagina) {
      this.listarEquipes(this.montarParametros({
        page: pagina.current_page,
        current_page: pagina.current_page,
        per_page: pagina.per_page,
        exibirItensDeletados: this.exibirItensDeletados
      }))
    },

    filtrarEquipesDeletados(event) {
      this.exibirItensDeletados = event
      this.listarEquipes(this.montarParametros({
        exibirItensDeletados: this.exibirItensDeletados
      }))
    },

    podeEditarOuDeletarEquipe(item) {
      const nomeEquipe = item.nome
      return nomeEquipe !== 'Equipe Claro' && nomeEquipe !== 'Equipe Provedor'
    },
    
    editarItem(item) {
      this.equipesSelecionadas = [item]
      setTimeout(() => {
        this.editarSelecionado()
      }, 50)
    },

    excluirItem(item) {
      this.equipesSelecionadas = [item]
      setTimeout(() => {
        this.deletarSelecionados()
      }, 50)
    },

    reloadData() {
      this.listarEquipes();
    },

  }
}
</script>